var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],attrs:{"data-type":"phone","type":"text"},domProps:{"value":(_vm.content)},on:{"keyup":_vm.formatPhone,"input":function($event){if($event.target.composing){ return; }_vm.content=$event.target.value}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f2fc3b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/phone.vue
// module id = fAeo
// module chunks = 0